/** @jsx React.DOM */
/**
 * Notes Item View
 *
 * A single note within a list of notes.
 */
var React = require("react");
var Backbone = require("exoskeleton");

module.exports = React.createClass({displayName: 'exports',
  // --------------------------------------------------------------------------
  // Events
  // --------------------------------------------------------------------------
  // [BB] Navigation, models.
  viewNote: function (ev) {
    ev.preventDefault();
    Backbone.history.navigate(
      "note/" + this.props.note.id + "/view", { trigger: true });
  },
  editNote: function (ev) {
    ev.preventDefault();
    Backbone.history.navigate(
      "note/" + this.props.note.id + "/edit", { trigger: true });
  },
  deleteNote: function () {
    this.props.note.destroy();
  },

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------
  render: function () {
    return (/*jshint ignore:start */
      React.createElement("tr", {id: this.props.note.id, 
          'data-qa-name': "notes-item"}, 
        React.createElement("td", null, 
          React.createElement("a", {className: "notes-item-title", 
             'data-qa-name': "notes-item-title", 
             href: this.props.note.id ? "/note/" + this.props.note.id + "/view" : "#", 
             onClick: this.viewNote}, 
            this.props.note.get("title")
          )
        ), 
        React.createElement("td", {className: "notes-item-action"}, 
          React.createElement("div", {className: "btn-group btn-group-sm pull-right"}, 
            React.createElement("div", {className: "btn btn-default", 
                 'data-qa-name': "notes-item-edit", 
                 onClick: this.editNote}, 
              React.createElement("a", {className: "glyphicon glyphicon-pencil", 
                 href: this.props.note.id ? "/note/" + this.props.note.id + "/edit" : "#"
                 })
            ), 
            React.createElement("div", {className: "btn btn-default", 
                 'data-qa-name': "notes-item-delete", 
                 onClick: this.deleteNote}, 
              React.createElement("span", {className: "glyphicon glyphicon-trash"})
            )
          )
        )
      )
    /*jshint ignore:end */);
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/page/notes/item.jsx
 ** module id = 100
 ** module chunks = 0
 **/